import { useMemo } from 'react'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { relatorioColumns } from './columns/_columns'
import { AtendimentoReport } from '../../../meus-atendimentos/meus-atendimentos-list/core/_models'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { RelatorioExpandedRow } from './columns/RelatorioExpandedRow'
import { useT } from '_metronic/i18n/Metronici18n'

export const RelatorioTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { hasFilters, clearFilters } = useListFilters()
  const { t } = useT()
  const columns = useMemo(() => relatorioColumns(t), [t])

  const emptyState = hasFilters ? (
    <TableEmptyState
      title='Nenhum atendimento encontrado'
      description='Revise o período e os filtros aplicados.'
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      title='Nenhum atendimento para exibir'
      description='Os atendimentos aparecem aqui conforme forem solicitados.'
    />
  )

  return (
    <CustomTable<AtendimentoReport>
      id='kt_table_relatorios'
      ariaLabel='Relatório de atendimentos'
      itemLabel={{ singular: 'atendimento', plural: 'atendimentos' }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      queryHooks={{ useQueryRequest, useQueryResponse }}
      // Os detalhes já vêm na própria linha.
      enableExpand
      onExpandFetch={async (row) => row.original}
      getExpandLabel={(row) => row.paciente?.nome || row.protocolo || `atendimento ${row.id}`}
      renderExpand={(data: AtendimentoReport, loading) => (
        <RelatorioExpandedRow data={data} isLoading={loading} />
      )}
    />
  )
}
